
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLimitsAttention as ObiLimitsAttentionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-limits-attention.js';
 
 
 

 
 export const ObiLimitsAttention = createComponent({
   react: React,
   tagName: 'obi-limits-attention',
   elementClass: ObiLimitsAttentionElement,
   events: {
     
   }
  });
 
 